class MatchType {
  SINGLE = 'SINGLE';
  OPENDOUBLE = 'OPENDOUBLE'
}

export default MatchType;


